import * as API from "middleware/api";

export const updateProcessRequest = (data) =>
    API.executeWithAccessToken("/pay.multiline.salary.status", { transactionId: data });

export default { updateProcessRequest };
